import React, { Component, Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { withFormik, Field } from 'formik';
import * as yup from 'yup';

import InputFeedback from '../InputFeedback';

const ChangeEmailSchema = yup.object().shape({
  currentEmail: yup
    .string()
    .email('Invalid email address')
    .required("Email can't be empty"),
  newEmail: yup
    .string()
    .email('Invalid email address')
    .required("Email can't be empty"),
});

class ChangeEmailModal extends Component {
  render() {
    const { isOpen, toggle } = this.props;
    const { isSubmitting, handleSubmit, isValid, touched, errors } = this.props;
    return (
      <Fragment>
        <Modal isOpen={isOpen} toggle={toggle} className={this.props.className}>
          <ModalHeader toggle={toggle}>
            <div className="h2-title">Change Email</div>
          </ModalHeader>
          <div className="separator-line" />
          <ModalBody>
            <div className="profile-modal">
              <div className="profile-modal__descr">
                <div className="position-relative form-group">
                  <div className="form-group__top">
                    <label
                      htmlFor="profile-current-email"
                      className="form-group__label">
                      Current Email
                    </label>
                  </div>
                  <Field
                    name="currentEmail"
                    render={({ field }) => (
                      <input
                        id="profile-current-email"
                        type="email"
                        className="form-input input-border form-control"
                        {...field}
                      />
                    )}
                  />
                  <InputFeedback
                    error={touched.currentEmail && errors.currentEmail}
                  />
                </div>
                <div className="position-relative form-group">
                  <div className="form-group__top">
                    <label
                      htmlFor="profile-new-email"
                      className="form-group__label">
                      New Email
                    </label>
                  </div>
                  <Field
                    name="newEmail"
                    render={({ field }) => (
                      <input
                        id="profile-new-email"
                        type="email"
                        className="form-input input-border form-control"
                        {...field}
                      />
                    )}
                  />
                  <InputFeedback error={touched.newEmail && errors.newEmail} />
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="blue"
              className="m-r-15"
              onClick={handleSubmit}
              disabled={!isValid || isSubmitting}>
              {isSubmitting ? 'Loading' : 'Save'}
            </Button>{' '}
            <Button color="blue" className="outline" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}
export default withFormik({
  mapPropsToValues: () => ({
    currentEmail: '',
    newEmail: '',
  }),
  isInitialValid: false,
  validationSchema: ChangeEmailSchema,
  handleSubmit: async (values, { props, setSubmitting, setErrors }) => {
    await props.handleSubmit(values, setSubmitting, setErrors);
  },
})(ChangeEmailModal);



// WEBPACK FOOTER //
// ./src/components/ChangeEmailModal/ChangeEmailModal.js